// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "three" + "." + "cb1dbc76d8348ff1" + ".js";
};